;(function ($) {
	"use strict";

	function AffiliatesGridRandomizer() {
		var fn = {
			init: function () {
				fn.randomizeGrids();
			},

			randomizeGrids: function () {
				const $grids = $('.affiliates-grid[data-random-affiliates]');
				
				if (!$grids.length) return;

				$grids.each(function () {
					const $grid = $(this);
					const count = parseInt($grid.data('random-affiliates'));
					const affiliatesData = $grid.data('affiliates');
					const $container = $grid.find('[data-grid-container]');

					if (!$container.length || !affiliatesData || affiliatesData.length === 0) return;
					const selected = fn.getRandomSelection(affiliatesData, count);
					const html = fn.generateAffiliateItems(selected);
					$container.html(html);
				});
			},

			getRandomSelection: function (array, count) {
                const pool = [...array];
                const selected = [];
                const selectCount = Math.min(count, pool.length);
                
                for (let i = 0; i < selectCount; i++) {
                    const randomIndex = Math.floor(Math.random() * pool.length);
                    selected.push(pool[randomIndex]);
                    pool.splice(randomIndex, 1);
                }
                
                return selected;
            },

			generateAffiliateItems: function (affiliates) {
                return affiliates.map(function (affiliate) {
                    const hasUrl = affiliate.url && affiliate.url.trim() !== '';
                    
                    let html = '<div class="affiliates-grid__grid-item">';
                    
                    if (hasUrl) {
                        html += `<a class="affiliates-grid__grid-item-link editor-disable" href="${affiliate.url}" target="__blank" rel="noopener noreferrer">`;
                    }
                    
                    html += '<div class="affiliates-grid__border-element"></div>';
                    html += '<div class="affiliates-grid__grid-item-image-wrapper">';
                    html += `<img class="affiliates-grid__grid-item-image" src="${affiliate.logo_url}" width="${affiliate.logo_width}" height="${affiliate.logo_height}" alt="${affiliate.title}">`;
                    html += '</div>';
                    html += `<span class="affiliates-grid__grid-item-text">${affiliate.title}</span>`;
                    
                    if (hasUrl) {
                        html += '</a>';
                    }
                    
                    html += '</div>';
                    
                    return html;
                }).join('');
            },
		};

		$(fn.init);
	}

	new AffiliatesGridRandomizer();
})(jQuery);